




























import { GetMarketplaceProductResponse } from "@/classes/TayehApi/TyMarketplace";
import { Component, Prop, Vue } from "vue-property-decorator";
import MarketplaceImage from "../MarketplaceImage.vue";

    @Component({
        components: {
            MarketplaceImage
        }
    })
    export default class MarketplaceProduct extends Vue {
        @Prop() product: GetMarketplaceProductResponse;


        
        public get has_off() : boolean {
            return this.product.price_with_off!==this.product.price;
        }
        
        
        public get image() : {url: string, alt: string} {
            return {
                url: this.product.image?.url||null,
                alt: this.product.image?.alt||'تایه'
                }
        }

        public get name() : string {
            return this.product.name;
            // const trimed_name = this.product.name.trim().slice(0, 32)
            // return trimed_name+(this.product.name.length>32?'...':'');
        }
        
    }
